<template>
  <div>
    <card class="card-user">
      <template slot="header">
        <h4 class="card-title">{{ $t('distributors.detailsTitle') }}</h4>
      </template>
      <div class="author">
        <div class="block block-one"></div>
        <!--        <div class="block block-two"></div>-->
        <div class="block block-three"></div>
        <div class="block block-four"></div>
      </div>
      <div v-loading="loading">
        <table v-if="details">
          <tr>
            <td><label>{{ $t('generic.id') }}:</label></td>
            <td class="pl-2">{{ details.id }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('distributors.details.company_name') }}:</label></td>
            <td class="pl-2">{{ details.company_name }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('generic.status') }}:</label></td>
            <td class="pl-2">{{ details.status }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('distributors.details.type') }}:</label></td>
            <td class="pl-2">{{ details.type }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('distributors.details.email') }}:</label></td>
            <td class="pl-2">{{ details.email }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('distributors.details.contact_number') }}:</label></td>
            <td class="pl-2">{{ details.contact_number }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('distributors.details.cidrs') }}:</label></td>
            <td class="pl-2">{{ details.cidrs }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('distributors.details.client_access_status') }}:</label></td>
            <td class="pl-2">{{ details.client_access_status }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('generic.created') }}:</label></td>
            <td class="pl-2">{{ details.created_at | time }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('distributors.details.last_login_at') }}:</label></td>
            <td class="pl-2">
              <span v-if="details.last_login_at">{{ details.last_login_at | time }}</span>
            </td>
          </tr>
          <tr>
            <td><label>{{ $t('generic.createdBy') }}:</label></td>
            <td class="pl-2">{{ details.created_by }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('generic.updated') }}:</label></td>
            <td class="pl-2">{{ details.updated_at | time }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('generic.updatedBy') }}:</label></td>
            <td class="pl-2">{{ details.modified_by }}</td>
          </tr>
        </table>
        <div class="button-container mt-3"
             v-if="details && $auth.can({distributor: 'delete'}, 'permissions')">
          <div class="row">
            <div class="col-md-6" v-if="$auth.can({distributor: 'update'}, 'permissions')">
              <edit-distributor :current-details="details"/>
            </div>
            <div class="col-md-6" v-if="$auth.can({distributor: 'delete'}, 'permissions')">
              <el-tooltip :content="$t('distributors.delete.deleteBtnTooltip')"
                          effect="light"
                          :open-delay="300"
                          placement="bottom"
                          class="m-0">
                <base-button block type="danger" @click.native="handleDelete()">
                  <i class="tim-icons icon-simple-remove pr-2"/> {{ $t('distributors.delete.deleteBtnLabel') }}
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import swal from "sweetalert2";
import EditDistributor from "../EditDistributor";

export default {
  name: "DistributorDetails",
  components: {
    EditDistributor
  },
  computed: {
    ...mapState({
      loading: state => state.distributors.loading,
      error: state => state.distributors.error,
      details: state => state.distributors.single,
    }),
  },
  methods: {
    ...mapActions(['GetDistributor', 'DeleteDistributor']),
    handleDelete(index, row) {
      swal({
        title: this.$t('distributors.delete.text'),
        text: `'${this.details.company_name}'`,
        confirmButtonText: this.$t('distributors.delete.actionBtnLabel'),
        cancelButtonText: this.$t('distributors.delete.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          const details = this.details
          this.DeleteDistributor(this.details.id).then(() => {
            if (this.error == null) {
              this.$notify({
                type: 'success',
                message: this.$t('distributors.delete.deletedNotification', {
                  company_name: this.details.company_name
                }),
                icon: 'tim-icons icon-alert-circle-exc'
              })
              this.$router.push({name: 'distributors'})
            }

          })
        }
      });
    },
  },
  mounted() {
    this.GetDistributor(this.$route.params.id)
  }
};
</script>
